class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.item = $(this).closest('.productView');
        this.isFullWidth = this.item.closest('.product-full-width').length == 1 || this.item.closest('.product-full-width-2').length == 1;

        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    connectedCallback() {
        // Ensure DOM is ready and children are parsed
        setTimeout(() => {
            this.onVariantInit();
        }, 0);
    }

    onVariantInit(){
        this.updateOptions();
        this.updateMasterId();
        this.updateMedia(1500, 'init');
        this.renderProductAjaxInfo();
        this.renderProductInfo();
        if (this.currentVariant) {
            this.updateAttribute(false, !this.currentVariant.available);
        } else {
            this.updateAttribute(true);
        }
        try { this.updateVariantStatuses(); } catch(e) { console.warn('Variant statuses update failed', e); }
        try { this.updateEnzoStepStateMachine(); } catch(e) { console.warn('Step state machine failed', e); }
    }
    
    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.updatePickupAvailability();
        try { this.updateVariantStatuses(); } catch(e) { console.warn('Variant statuses update failed', e); }
        try { this.updateEnzoStepStateMachine(); } catch(e) { console.warn('Step state machine failed', e); }
      
        if (!this.currentVariant) {
            this.updateAttribute(true);
            this.updateStickyAddToCart(true);
        } else {
            this.updateMedia(200, 'change');
            if (!document.querySelector('.featured-product')) {
                this.updateURL();
            }
            this.updateVariantInput();
            this.renderProductAjaxInfo();
            this.renderProductInfo();
            this.updateProductInfo();
            this.updateAttribute(false, !this.currentVariant.available);
            this.updateStickyAddToCart(false, !this.currentVariant.available);
            this.checkQuantityWhenVariantChange();
        }
        try { this.updateEnzoStepStateMachine(); } catch(e) { console.warn('Step state machine failed', e); }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    decodeOptions() {
        this.options = this.options.map(option => {
            const parsedOption = this.decodeOption(option)
            return parsedOption
        })
    }
  
    decodeOption(option) {
      if (option) {
          return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/')
        } else {
          return null
        }
    }

    encodeOption(option) {
        if (option) {
          return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash')
        } else {
          return null
        }
    }
    
    updateMasterId() {
        this.decodeOptions()
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });

        if (this.item.find('[data-filter]').length && this.currentVariant?.featured_media && this.currentVariant.featured_media.alt != null) {
            this.item.find('[data-filter]:checked').attr('data-value-default-lang', this.currentVariant?.featured_media.alt.toLowerCase().replace(/ /g,"-"));
        }
    }      

    updateMedia(time, status) {
        try {
            if (status === 'init') {
                // ENZO CRO FIX: Sayfa ilk açılışında yaşam alanı / oda / gece görseli KORUNUR!
                // Müşteri bir renk/Kelvin swatch'ına bizzat tıklamadıkça galeri stüdyo dekupesine zıplamaz.
                return;
            }
            const variantImgSrc = this.currentVariant?.featured_media?.src || this.currentVariant?.featured_image?.src;
            if (variantImgSrc) {
                const cleanSrc = variantImgSrc.startsWith('//') ? 'https:' + variantImgSrc : variantImgSrc;
                
                // 1. Slick ana galeri slider'ını Slide 0'a (vitrin görseli) getir
                const $nav = $('.productView-nav');
                if ($nav.length && $nav.hasClass('slick-initialized')) {
                    const isNight = document.documentElement.classList.contains('enzo-dark-mode');
                    if (status === 'init' && isNight) {
                        $nav.slick('slickGoTo', 1);
                    } else {
                        $nav.slick('slickGoTo', 0);
                    }
                }
                
                // 2. Vitrin görselinin (Slide 0) src & srcset değerlerini güncelle (Gece overlay'i hariç)
                const firstImgs = document.querySelectorAll(
                    '.productView-nav .productView-image[data-index="1"] img[data-main-image], ' +
                    '.productView-nav .slick-slide[data-slick-index="0"] img[data-main-image], ' +
                    '.productView-nav .productView-image:first-child img[data-main-image], ' +
                    '#ProductSection-' + this.dataset.section + ' .productView-nav .productView-image:first-child img[data-main-image]'
                );
                const targetImgs = firstImgs.length > 0 ? firstImgs : document.querySelectorAll(
                    '.productView-nav .productView-image[data-index="1"] img:not(.product-media-night-hover), ' +
                    '.productView-nav .slick-slide[data-slick-index="0"] img:not(.product-media-night-hover)'
                );
                targetImgs.forEach(img => {
                    if (img.classList.contains('product-media-night-hover')) return;
                    img.src = cleanSrc;
                    img.srcset = cleanSrc;
                    if (img.dataset.src) img.dataset.src = cleanSrc;
                });
                
                // 3. Zoom / Fancybox linkini güncelle
                const zoomLinks = document.querySelectorAll(
                    '.productView-nav .productView-image[data-index="1"] [data-zoom-image], ' +
                    '.productView-nav .slick-slide[data-slick-index="0"] [data-zoom-image], ' +
                    '.productView-nav .productView-image:first-child [data-zoom-image], ' +
                    '.productView-nav .productView-image[data-index="1"] [data-fancybox], ' +
                    '.productView-nav .slick-slide[data-slick-index="0"] [data-fancybox], ' +
                    '.productView-nav .productView-image:first-child [data-fancybox]'
                );
                zoomLinks.forEach(link => {
                    if (link.hasAttribute('data-zoom-image')) link.setAttribute('data-zoom-image', cleanSrc);
                    link.setAttribute('href', cleanSrc);
                });
                
                // 4. Birinci thumbnail görselini de seçilen varyant ile senkronize et
                const firstThumbImgs = document.querySelectorAll(
                    '.productView-for .productView-thumbnail:first-child img, ' +
                    '.productView-for .slick-slide[data-slick-index="0"] img'
                );
                firstThumbImgs.forEach(tImg => {
                    tImg.src = cleanSrc;
                    tImg.srcset = cleanSrc;
                });
            }
            
            // Standart element varsa tıkla
            const featuredMediaId = this.currentVariant?.featured_media?.id;
            if (featuredMediaId) {
                const newMedia = document.querySelectorAll(
                    `[data-media-id="${this.dataset.section}-${featuredMediaId}"]`
                );
                if (newMedia.length > 0) {
                    window.setTimeout(() => {
                        $(newMedia).trigger('click');
                    }, time);
                }
            }
        } catch (e) {
            console.error('Update media failed:', e);
        }
    }

    scrollToBlock(block) {
        const headerHeight = document.querySelectorAll('.section-header-navigation')[0]?.getBoundingClientRect().height 
        const announcementBarHeight = document.querySelectorAll('.announcement-bar')[0]?.getBoundingClientRect().height 
        const positionTop = block.getBoundingClientRect().top - headerHeight - announcementBarHeight 

        window.scrollTo({
            top: positionTop,
            behavior: 'smooth'
        })
    }

    updateURL() {
        if (!this.currentVariant || !this.currentVariant.id) return;
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        if (!this.currentVariant || !this.currentVariant.id) return;
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}`);

        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            if (input) {
                input.value = this.currentVariant.id;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant?.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    renderProductAjaxInfo() {
        if (!this.currentVariant || !this.currentVariant.id) return;
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `product-price-${this.dataset.product}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(id);
                const source = html.getElementById(id);

                const property = `product-property-${this.dataset.product}`;
                const destinationProperty = document.getElementById(property);
                const sourceProperty = html.getElementById(property);

                if (source && destination) {
                    destination.innerHTML = source.innerHTML;
                }

                if (this.checkNeedToConvertCurrency()) {
                    let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');

                    Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                }

                if(destinationProperty) {
                    if (sourceProperty) {
                        destinationProperty.innerHTML = sourceProperty.innerHTML;
                        destinationProperty.style.display = 'table';
                    } else{
                        destinationProperty.style.display = 'none';
                    }
                } else if (sourceProperty) {
                    document.querySelector('.productView-product')?.insertBefore(sourceProperty, document.querySelector('.productView-options'));
                }

                document.getElementById(`product-price-${this.dataset.product}`)?.classList.remove('visibility-hidden');
                this.updateBadgeSale()
        });
    }

    renderProductInfo() {
        if (!this.currentVariant) return;
        if(this.item.find('[data-sku]').length > 0){
            this.item.find('[data-sku] .productView-info-value').text(this.currentVariant.sku || '');
        }

        if(this.item.find('[data-barcode]').length > 0){
            this.item.find('[data-barcode] .productView-info-value').text(this.currentVariant.barcode || '');
        }

        var inventory = this.currentVariant?.inventory_management;

        if(inventory != null) {
            var arrayInVarName = `product_inven_array_${this.dataset.product}`,
                inven_array = window[arrayInVarName];

            if(inven_array != undefined) {
                var inven_num = inven_array[this.currentVariant.id],
                    inputQuantity = this.item.find('input[name="quantity"]'),
                    buttonSubmit = this.item.find('button#product-add-to-cart'),
                    inventoryQuantity = parseInt(inven_num);

                if(inputQuantity.length > 0) {
                    inputQuantity.attr('data-inventory-quantity', inventoryQuantity);
                } else {
                    buttonSubmit.attr('data-inventory-quantity', inventoryQuantity);
                }

                if(this.item.find('[data-inventory]').length > 0){
                    if(inventoryQuantity > 0){
                        const showStock = this.item.find('[data-inventory]').data('stock-level');
                        if (showStock == 'show') {
                            this.item.find('[data-inventory] .productView-info-value').text(inventoryQuantity+' '+window.inventory_text.inStock);
                        }
                        else {
                            this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.inStock);
                        }
                    } else {
                        this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.outOfStock);
                    }
                }

                if (typeof hotStock === 'function') hotStock(inventoryQuantity);
            }
        }

        if(this.item.find('.productView-stickyCart').length > 0){
            const sticky = this.item.find('.productView-stickyCart');
            const optionSticky = sticky.find('.select__select');

            if (this.currentVariant?.id) optionSticky.val(this.currentVariant.id);
        }
    }

    updateProductInfo() {
        if (!this.currentVariant || !this.currentVariant.id) return;
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const description = `[data-product-description-${this.dataset.product}]`
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destinationDesc = document.querySelector(description);
                const sourceDesc = html.querySelector(description);

                if (sourceDesc && destinationDesc) {
                    destinationDesc.innerHTML = sourceDesc.innerHTML;
                    if (destinationDesc.closest('.toggle-content--height')){
                        destinationDesc.style.maxHeight = null;
                    }
                }
        });
    }

    updateAttribute(unavailable = true, disable = true){
        const addButton = document.getElementById(`product-form-${this.dataset.product}`)?.querySelector('[name="add"]');
        var quantityInput = this.item.find('input[name="quantity"]'),
            notifyMe = this.item.find('.productView-notifyMe'),
            hotStock = this.item.find('.productView-hotStock'),
            buttonAddtocart = this.item.find('.product-form__submit'),
            maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));

        if (isNaN(maxValue)) {
            maxValue = maxValue = parseInt(buttonAddtocart.attr('data-inventory-quantity'));
        } else {
            maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
        }
        
        if(unavailable){
            quantityInput.attr('disabled', true);
            notifyMe.slideUp('slow');
            quantityInput.closest('quantity-input').addClass('disabled');
            if(hotStock.length > 0) hotStock.addClass('is-hiden');
            try { this.updateEnzoStepStateMachine(); } catch(e) {}
        } else {
            if (disable) {
                var text = window.variantStrings.soldOut,
                    subTotal = 0,
                    price = this.currentVariant?.price;

                const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
                const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

                if (window.subtotal.show) {
                    let qty = quantityInput.val() || 1;

                    subTotal = qty * price;
                    subTotal = Shopify.formatMoney(subTotal, window.money_format);
                    subTotal = extractContent(subTotal);

                    const moneySpan = document.createElement('span')
                    moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
                    moneySpan.innerText = subTotal
                    document.body.appendChild(moneySpan)

                    if (this.checkNeedToConvertCurrency()) {
                        let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }

                    subTotal = moneySpan.innerText
                    $(moneySpan).remove()

                    if (window.subtotal.style == '1') {
                        const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                        if (pdView_subTotal != null) {
                            pdView_subTotal.textContent = subTotal;
                        }
                    } else if (window.subtotal.style == '2') {
                        text = window.subtotal.text.replace('[value]', subTotal);
                    }
                } else {
                    subTotal = Shopify.formatMoney(price, window.money_format);
                    subTotal = extractContent(subTotal);
                }

                quantityInput.attr('data-price', this.currentVariant?.price);
                quantityInput.attr('disabled', true);
                if (addButton != null){
                    addButton.setAttribute('disabled', true);
                    addButton.textContent = text;
                    addButton.style.removeProperty('font-size');
                }


                quantityInput.closest('quantity-input').addClass('disabled');

                if (subTotal != 0 && stickyPrice.length) {
                    stickyPrice.text(subTotal);
                }

                const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
                const thisComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');
                const compare_at_price = this.currentVariant?.compare_at_price;
                const current_at_price = this.currentVariant?.price;

                if(compare_at_price == current_at_price) {
                    thisStickyPrice.removeClass('has-compare-price');
                    thisComparePrice.remove();
                } else {
                    if (compare_at_price) {
                        thisStickyPrice.addClass('has-compare-price');
                        if (thisComparePrice.length) {
                            thisComparePrice.attr('data-compare-price', compare_at_price);
                        } else {
                            thisStickyPrice.prepend(`<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`);
                        }
                    } else {
                        thisStickyPrice.removeClass('has-compare-price');
                        thisComparePrice.remove();
                    }
                }

                if (subTotal != 0 && stickyComparePrice.length && window.subtotal.show) {
                    let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price'),
                        qty = quantityInput.val() || 1;
                    comparePrice = qty * comparePrice;
                    comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                    comparePrice = extractContent(comparePrice);
                    stickyComparePrice.text(comparePrice);
                }

                if (notifyMe.length > 0) {
                    notifyMe.find('.halo-notify-product-variant').val(this.currentVariant.title);
                    notifyMe.find('.notifyMe-text').empty();
                    notifyMe.slideDown('slow');
                }
            } else {
                var text,
                    subTotal = 0,
                    price = this.currentVariant?.price;

                const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');

                if (window.subtotal.show) {
                    let qty = quantityInput.val() || 1;

                    subTotal = qty * price;
                    subTotal = Shopify.formatMoney(subTotal, window.money_format);
                    subTotal = extractContent(subTotal);

                    const moneySpan = document.createElement('span')
                    moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
                    moneySpan.innerText = subTotal
                    document.body.appendChild(moneySpan)

                    if (this.checkNeedToConvertCurrency()) {
                        let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }

                    subTotal = moneySpan.innerText
                    $(moneySpan).remove()

                    if (window.subtotal.style == '1') {
                        const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                        if (pdView_subTotal != null) {
                            pdView_subTotal.textContent = subTotal;
                        }

                        if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                            text = window.variantStrings.preOrder;
                        } else {
                            text = window.variantStrings.addToCart;
                        }
                    } else if (window.subtotal.style == '2') {
                        if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                            text = window.variantStrings.preOrder;
                        } else {
                            text = window.subtotal.text.replace('[value]', subTotal);
                            $('#show-sticky-product').text(text);
                            $('#product-sticky-add-to-cart').text(text);
                        }
                    }
                } else {
                    subTotal = Shopify.formatMoney(price, window.money_format);
                    subTotal = extractContent(subTotal);
                    if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                        text = window.variantStrings.preOrder;
                    } else {
                        text = window.variantStrings.addToCart;
                    }
                }

                quantityInput.attr('data-price', this.currentVariant?.price);
                quantityInput.attr('disabled', false);
                if (addButton != null){
                    addButton.removeAttribute('disabled');
                    addButton.textContent = text;
                    addButton.classList.remove('enzo-btn-need-options');
                    addButton.style.removeProperty('font-size');
                }

                var enzoBadge = document.getElementById('enzo-variant-guidance-badge');
                if (enzoBadge) {
                    enzoBadge.classList.add('is-ready');
                    var bText = enzoBadge.querySelector('.enzo-badge-text');
                    if (bText) bText.innerText = "Ürün Stokta Hazır • 1-3 İş Gününde Sigortalı Kargo";
                }


                quantityInput.closest('quantity-input').removeClass('disabled');

                if (subTotal != 0 && stickyPrice.length) {
                    stickyPrice.text(subTotal);
                }

                const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
                const thisComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');
                const compare_at_price = this.currentVariant?.compare_at_price;
                const current_at_price = this.currentVariant?.price;

                if(compare_at_price == current_at_price) {
                    thisStickyPrice.removeClass('has-compare-price');
                    thisComparePrice.remove();
                } else {
                    if (compare_at_price) {
                        thisStickyPrice.addClass('has-compare-price');
                        if (thisComparePrice.length) {
                            thisComparePrice.attr('data-compare-price', compare_at_price);
                            
                            const compare_at_price_sticky = Shopify.formatMoney(compare_at_price, window.money_format);
                            const comparePrice_sticky = extractContent(compare_at_price_sticky);
                            thisComparePrice.text(comparePrice_sticky);
                            
                            if (this.checkNeedToConvertCurrency()) {
                                let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                                Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                            }

                            thisStickyPrice.prepend(`<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`);
                            thisComparePrice.remove();
                        } else {
                            thisStickyPrice.prepend(`<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`);
                        }
                    } else {
                        thisStickyPrice.removeClass('has-compare-price');
                        thisComparePrice.remove();
                    }
                }

                const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');
                if (subTotal != 0 && stickyComparePrice.length && window.subtotal.show) {
                    let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price'),
                        qty = quantityInput.val() || 1;
                    comparePrice = qty * comparePrice;
                    comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                    comparePrice = extractContent(comparePrice);
                    stickyComparePrice.text(comparePrice);
                }

                if (notifyMe.length > 0) {
                    notifyMe.slideUp('slow');
                }
            }
        }
    }

    updateStickyAddToCart(unavailable = true, disable = true){
        if(this.item.find('.productView-stickyCart').length > 0){
            const sticky = this.item.find('.productView-stickyCart');
            const itemImage = sticky.find('.sticky-image');
            const option = sticky.find('.select__select');
            const input = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('input[name="id"]');
            const button = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('[name="add"]');
            var quantityInput = this.item.find('input[name="quantity"]');
            var submitBtn = $('.product-form__submit');
            var maxValue;

            if (quantityInput.length > 0) {
                maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
            } else {
                maxValue = parseInt(submitBtn.attr('data-inventory-quantity'));
            }
          
            if(unavailable){
                try { this.updateEnzoStepStateMachine(); } catch(e) {}
            } else {


                if (!this.currentVariant) return;

                const image = this.currentVariant?.featured_image;
                
                if (image != null) {
                    itemImage.find('img').attr({
                        'src': image.src,
                        'srcset': image.src,
                        'alt': image.alt
                    });
                }

                option.val(this.currentVariant.id);

                if (disable) {
                    var text = window.variantStrings.soldOut;

                    button.setAttribute('disabled', true);
                    button.textContent = text;
                    button.style.removeProperty('font-size');
                } else {


                    if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                        text = window.variantStrings.preOrder;
                    } else {
                        text = window.variantStrings.addToCart;
                    }

                    button.removeAttribute('disabled');
                    button.textContent = text;
                    button.style.removeProperty('font-size');
                }



                input.value = this.currentVariant.id;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }


    updateMiniPreview() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset, .product-form__input'));
        if (fieldsets.length === 0) return;

        const firstFs = fieldsets[0];
        if (!firstFs) return;

        let previewWrap = this.querySelector('#enzo-mini-preview-wrap');
        if (!previewWrap) {
            previewWrap = document.createElement('div');
            previewWrap.id = 'enzo-mini-preview-wrap';
            previewWrap.className = 'enzo-mini-preview-wrap';
            previewWrap.innerHTML = `
                <div class="enzo-mini-preview-square" id="enzo-mini-preview-square" title="Büyük Görseli İncele" role="button" tabindex="0" aria-label="Büyük Görseli İncele">
                    <img id="enzo-mini-preview-img" src="" alt="Seçilen Ürün" width="140" height="140" loading="lazy" />
                    <span class="enzo-square-badge">Büyük Görseli İncele ↗</span>
                </div>
            `;
            this.appendChild(previewWrap);

            const squareBtn = previewWrap.querySelector('#enzo-mini-preview-square');
            const handleScroll = (e) => {
                e.preventDefault();
                e.stopPropagation();
                const mediaGallery = document.querySelector('.productView-images') || 
                                     document.querySelector('.productView-image') || 
                                     document.querySelector('.productView-nav');
                if (mediaGallery) {
                    const headerHeight = 70;
                    const pos = mediaGallery.getBoundingClientRect().top + window.pageYOffset - headerHeight;
                    window.scrollTo({ top: pos, behavior: 'smooth' });
                }
            };
            squareBtn.addEventListener('click', handleScroll);
            squareBtn.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') handleScroll(e);
            });
        }

        // Determine currently selected color (option 1) & kelvin (option 2)
        const checkedFirst = firstFs.querySelector('input:checked, option:checked:not([value=""])');
        const selectedColor = checkedFirst ? checkedFirst.value : null;

        const secondFs = fieldsets[1];
        const checkedSecond = secondFs ? secondFs.querySelector('input:checked, option:checked:not([value=""])') : null;
        const selectedKelvin = checkedSecond ? checkedSecond.value : null;

        // Fallback: Hiçbir varyant seçilmediğinde ürünün ana görselini göster
        let fallbackImgSrc = null;
        if (this.variantData && this.variantData.length > 0) {
            const firstWithImg = this.variantData.find(v => v.featured_image && (v.featured_image.src || v.featured_image));
            if (firstWithImg) {
                fallbackImgSrc = firstWithImg.featured_image.src || firstWithImg.featured_image;
            }
        }
        if (!fallbackImgSrc) {
            const domMainImg = document.querySelector('.productView-nav .productView-thumbnail:first-child img, .productView-images img, .productView-image img');
            if (domMainImg && domMainImg.src && !domMainImg.src.includes('data:image')) {
                fallbackImgSrc = domMainImg.currentSrc || domMainImg.src;
            }
        }

        // Find variant image for this color & kelvin
        let matchedVariant = null;
        if (selectedColor) {
            if (this.currentVariant && this.currentVariant.featured_image) {
                matchedVariant = this.currentVariant;
            } else if (this.variantData) {
                if (selectedColor && selectedKelvin) {
                    matchedVariant = this.variantData.find(v => {
                        const opts = v.options || [];
                        return (opts.includes(selectedColor) && opts.includes(selectedKelvin)) ||
                               (v.option1 === selectedColor && v.option2 === selectedKelvin) ||
                               (v.option2 === selectedColor && v.option1 === selectedKelvin);
                    });
                }
                if (!matchedVariant) {
                    matchedVariant = this.variantData.find(v => v.option1 === selectedColor && v.featured_image);
                }
                if (!matchedVariant) {
                    matchedVariant = this.variantData.find(v => v.option1 === selectedColor);
                }
            }
        }

        let activeImgSrc = null;
        let activeAlt = "Enzo Light Ürün Görseli";

        if (matchedVariant && matchedVariant.featured_image) {
            activeImgSrc = matchedVariant.featured_image.src || matchedVariant.featured_image;
            activeAlt = `${selectedColor || ''} ${selectedKelvin || ''}`.trim();
        } else if (fallbackImgSrc) {
            activeImgSrc = fallbackImgSrc;
            activeAlt = "Enzo Light Ana Görsel";
        }

        const imgEl = previewWrap.querySelector('#enzo-mini-preview-img');
        if (activeImgSrc && imgEl) {
            let imgSrc = activeImgSrc;
            if (imgSrc.startsWith('//')) imgSrc = 'https:' + imgSrc;
            
            // Format 600x sharp thumb for crystal clear details on high-res mobile displays
            let thumbSrc = imgSrc;
            if (thumbSrc.includes('.jpg') || thumbSrc.includes('.png')) {
                thumbSrc = thumbSrc.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_600x$1$2');
            }

            if (imgEl.src !== thumbSrc) {
                imgEl.style.opacity = '0';
                imgEl.src = thumbSrc;
                imgEl.alt = activeAlt;
                imgEl.onload = () => {
                    imgEl.style.opacity = '1';
                    previewWrap.classList.remove('enzo-preview-flash');
                    void previewWrap.offsetWidth;
                    previewWrap.classList.add('enzo-preview-flash');
                };
            }
            previewWrap.style.display = 'flex';
        } else {
            previewWrap.style.display = 'none';
        }
    }

    updateEnzoStepStateMachine() {
        const productForm = document.getElementById(`product-form-${this.dataset.product}`);
        const addButton = productForm ? productForm.querySelector('[name="add"]') : document.getElementById('product-add-to-cart');
        const stickyBtn = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('[name="add"]') || document.querySelector('[data-sticky-add-to-cart] [name="add"]');
        const guidanceBadge = document.getElementById('enzo-variant-guidance-badge');
        const bText = guidanceBadge ? guidanceBadge.querySelector('.enzo-badge-text') : null;
        const bDot = guidanceBadge ? guidanceBadge.querySelector('.enzo-badge-dot') : null;

        const fieldsets = Array.from(this.querySelectorAll('fieldset, .product-form__input'));
        if (fieldsets.length === 0) return;

        // Check which options are checked
        let missingIndex = -1;
        for (let i = 0; i < fieldsets.length; i++) {
            const fs = fieldsets[i];
            const checked = fs.querySelector('input:checked, select option:checked:not([value=""])');
            const inputs = fs.querySelectorAll('input[type="radio"], option');
            if (inputs.length > 0 && !checked) {
                missingIndex = i;
                break;
            }
        }

        // 1. Sahte Tükenmişlik Algısını Ayrıştırma ve Gizleme:
        // Eğer 1. seçenek (Kasa / Aksesuar Rengi) henüz seçilmemişse, 2. seçenekteki (Kelvin) "(mevcut değil)" ibarelerini temizle
        const firstFsChecked = fieldsets[0] ? fieldsets[0].querySelector('input:checked, select option:checked') : null;
        if (!firstFsChecked && fieldsets.length > 1) {
            for (let j = 1; j < fieldsets.length; j++) {
                const targetFs = fieldsets[j];
                const pills = targetFs.querySelectorAll('.soldout, .product-form__label, label, input, option');
                pills.forEach(el => {
                    el.classList.remove('soldout');
                    if (el.tagName === 'OPTION' || (el.tagName === 'LABEL' && !el.querySelector('.text'))) {
                        el.innerText = el.innerText.replace(/\s*\(mevcut değil\)/gi, '').replace(/\s*\(Sold out\)/gi, '').trim();
                    }
                });
                const spans = targetFs.querySelectorAll('label .text');
                spans.forEach(sp => {
                    sp.innerText = sp.innerText.replace(/\s*\(mevcut değil\)/gi, '').replace(/\s*\(Sold out\)/gi, '').trim();
                });
            }
        }

        // 2. Aşamalı Durum Makinesi (State Machine):
        if (missingIndex === -1 && this.currentVariant && this.currentVariant.available) {
            // DURUM 3: İki seçim de tamamlandı -> "Hemen Sepete Ekleyin"
            const readyText = "Hemen Sepete Ekleyin";
            
            [addButton, stickyBtn].forEach(btn => {
                if (btn) {
                    btn.removeAttribute('disabled');
                    btn.removeAttribute('aria-disabled');
                    btn.classList.remove('enzo-btn-step-guide', 'enzo-btn-need-options');
                    btn.classList.add('enzo-btn-ready');
                    btn.setAttribute('type', 'submit');
                    btn.textContent = readyText;
                    btn.dataset.missingStep = "";
                }
            });

            if (guidanceBadge) {
                guidanceBadge.className = 'enzo-variant-guidance-badge is-ready';
                if (bDot) bDot.innerText = "🟢";
                if (bText) bText.innerText = "1-3 İş Gününde Ücretsiz Kapında";
            }
        } else {
            // EKSİK ADIM VAR -> Durum 1 veya Durum 2
            let stepNum = (missingIndex === 0) ? 1 : 2;
            let missingFs = fieldsets[missingIndex] || fieldsets[0];
            let legendText = missingFs.querySelector('legend, .form__label')?.textContent || '';
            let isKelvin = /ışık|isik|kelvin|sıcaklık/i.test(legendText);

            let stepBtnText = "";
            let badgeMsg = "";

            if (stepNum === 1 && !isKelvin) {
                stepBtnText = "1. Adım: Kasa Rengini Seçin";
                badgeMsg = "1. Adım: Lütfen yukarıdan Kasa / Aksesuar Renginizi seçiniz.";
            } else if (stepNum === 2 || isKelvin) {
                stepBtnText = "2. Adım: Işık Rengini Seçin";
                badgeMsg = "2. Adım: Harika seçim! Şimdi lütfen Işık Renginizi (Kelvin) belirleyiniz.";
            } else {
                stepBtnText = `${stepNum}. Adımı Seçin`;
                badgeMsg = `${stepNum}. Adım: Lütfen seçiminizi yapınız.`;
            }

            [addButton, stickyBtn].forEach(btn => {
                if (btn) {
                    btn.removeAttribute('disabled'); // Allow click event to be captured!
                    btn.setAttribute('aria-disabled', 'true');
                    btn.setAttribute('type', 'button');
                    btn.classList.remove('enzo-btn-ready');
                    btn.classList.add('enzo-btn-step-guide', 'enzo-btn-need-options');
                    btn.textContent = stepBtnText;
                    btn.dataset.missingStep = missingIndex.toString();
                }
            });

            if (guidanceBadge) {
                guidanceBadge.className = `enzo-variant-guidance-badge step-${stepNum}`;
                if (bDot) bDot.innerText = "🟡";
                if (bText) bText.innerText = badgeMsg;
            }
        }

        // Live Mini Preview Sync
        try { this.updateMiniPreview(); } catch(e) {}
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    checkNeedToConvertCurrency() {
        var currencyItem = $('.dropdown-item[data-currency]');
        if (currencyItem.length) {
            return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
        } else {
            return;
        }
    }

    checkQuantityWhenVariantChange() {
        var quantityInput = this.closest('.productView-details').querySelector('input.quantity__input')
        var maxValue = parseInt(quantityInput?.dataset.inventoryQuantity);
        var inputValue = parseInt(quantityInput?.value);

        let value = inputValue 

        if (inputValue > maxValue && maxValue > 0) {
            value = maxValue
        } else {
            value = inputValue
        }

        if (value < 1 || isNaN(value)) value = 1 
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
            return checkedRadio ? checkedRadio.value : '';
        });
    }

    updateVariantStatuses() {
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        const inputLength = inputWrappers.length;
        const variant_swatch = [...this.querySelectorAll('.product-form__swatch')];
        
        inputWrappers.forEach((option, index) => {
            const checkedInput = option.querySelector(':checked');
            if (checkedInput) {
                const headerOption = option.querySelector('[data-header-option]');
                if (headerOption) headerOption.innerText = checkedInput.value;
            }
            
            if (index === 0 && inputLength > 1) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
            
            // Defensively get previous selected value
            let previousOptionSelected = '';
            if (index > 0 && inputWrappers[index - 1]) {
                const prevChecked = inputWrappers[index - 1].querySelector(':checked');
                if (prevChecked) previousOptionSelected = prevChecked.value;
            } else {
                const currentChecked = inputWrappers[index].querySelector(':checked');
                if (currentChecked) previousOptionSelected = currentChecked.value;
            }

            const selectedOptionOneVariants = this.variantData ? this.variantData.filter(variant => {
                const firstChecked = this.querySelector(':checked');
                return firstChecked && firstChecked.value === variant.option1;
            }) : [];

            // ENZO CRO LOGICAL CONTROL:
            // Eğer önceki seçenek (ör. 1. Adım: Aksesuar Rengi) henüz seçilmemişse:
            // Kelvin / 2. Adım seçeneklerinin yanına ASLA "(mevcut değil)" yazılmamalı ve .soldout eklenmemelidir!
            if (!previousOptionSelected || selectedOptionOneVariants.length === 0) {
                optionInputs.forEach(input => {
                    input.classList.remove('soldout');
                    const rawVal = input.getAttribute('value') || '';
                    input.innerText = rawVal;
                    const lbl = input.id ? this.querySelector(`label[for="${input.id}"]`) : null;
                    if (lbl) {
                        lbl.classList.remove('soldout');
                        lbl.classList.add('available');
                        const txtSpan = lbl.querySelector('.text');
                        if (txtSpan) {
                            txtSpan.innerText = rawVal;
                        }
                    }
                });
                return;
            }

            const optionInputsValue = inputLength > 1 ? selectedOptionOneVariants.filter(variant => variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]) : (this.variantData || []).map(variantOption => variantOption[`option${ index + 1 }`]);
            const availableOptionInputsValue = inputLength > 1 ? selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]) : (this.variantData || []).filter(variant => variant.available).map(variantOption => variantOption[`option${ index + 1 }`]);
            
            this.setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue)
            if (variant_swatch.length > 1 && selectedOptionOneVariants.length > 0){
                this.updateImageSwatch(selectedOptionOneVariants)
            }
        });
    }

    updateImageSwatch(selectedOptionOneVariants) {
        const inputWrappers = this.querySelectorAll('.product-form__input');
        if(inputWrappers){
            inputWrappers.forEach((element, inputIndex) => {
                const imageSpan = element.querySelectorAll("label>span.pattern");
                const imageLabel = element.querySelectorAll("label");
                const imageSpanImage = element.querySelectorAll("label>span.expand>img");
                const inputList = element.querySelectorAll("input");

                inputList.forEach((item, index) => {
                    const image = selectedOptionOneVariants.filter(tmp => {
                        if (inputIndex == 0) return tmp.option1 == item.value;
                        if (inputIndex == 1) return tmp.option2 == item.value;
                        if (inputIndex == 2) return tmp.option3 == item.value;
                    });
    
                    if(image.length > 0) {
                        imageLabel[index].style.display = "inline-block";
                        if (imageSpan[index] != undefined && image[0].featured_image != null) imageSpan[index].style.backgroundImage = `url("${image[0].featured_image.src}")`;
                        if (imageSpanImage[index] != undefined && image[0].featured_image != null) imageSpanImage[index].srcset = image[0].featured_image.src;
                    }
                })
            });
        }
    }

    setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
        optionInputs.forEach(input => {
            const rawVal = input.getAttribute('value') || '';
            const lbl = input.id ? this.querySelector(`label[for="${input.id}"]`) : null;
            const txtSpan = lbl ? lbl.querySelector('.text') : null;

            if (availableOptionInputsValue.includes(rawVal)) {
                input.classList.remove('soldout');
                input.innerText = rawVal;
                if (lbl) {
                    lbl.classList.remove('soldout');
                    lbl.classList.add('available');
                }
                if (txtSpan) {
                    txtSpan.innerText = rawVal;
                }
            } else {
                input.classList.add('soldout');
                if (lbl) {
                    lbl.classList.add('soldout');
                    lbl.classList.remove('available');
                }
                const displayTxt = optionInputsValue.includes(rawVal) 
                    ? rawVal + ' (Sold out)' 
                    : (window.variantStrings && window.variantStrings.unavailable_with_option 
                        ? window.variantStrings.unavailable_with_option.replace('[value]', rawVal) 
                        : rawVal + ' (mevcut değil)');
                input.innerText = displayTxt;
                if (txtSpan) {
                    txtSpan.innerText = displayTxt;
                }
            }
        });
    }

    updateBadgeSale() {
        let badgeWrap = document.querySelector(".productView-badge");

        if (!badgeWrap) return;

        let badgeText = badgeWrap.querySelector(".productView-badge .badge.sale-badge"),
            badgeTextSaleType = badgeWrap.getAttribute('data-text-sale-badge'),
            priceCompare = document.querySelector(".productView-product .price__compare").getAttribute('data-compare'),
            priceLast = document.querySelector(".productView-product .price__sale .price__last").getAttribute('data-last'),
            percentSale = Math.round(((priceCompare - priceLast) / priceCompare) * 100);

        function renderSpan(text1, text2) {
            let spanElement = document.createElement('span');
            spanElement.classList.add('badge', 'sale-badge');
            let container = document.querySelector('.productView-badge');
            container.appendChild(spanElement);
            spanElement.innerText = `${text1} ${text2}%`
        }

        if (badgeWrap.classList.contains("has-badge-js")) {
            if (!priceCompare) {
                badgeWrap.querySelector(".badge.sale-badge")?.remove();
            } else {
                if (!badgeText) {
                    renderSpan(badgeTextSaleType, percentSale)
                } else {
                    badgeText.innerText = `${badgeTextSaleType} ${percentSale}%`
                }
            }
        } else {
            if (!priceCompare) {
                badgeWrap.querySelector(".badge.sale-badge")?.remove();
            } else {
                if (!badgeText) {
                    renderSpan(badgeTextSaleType, percentSale);
                } else {
                    badgeText.innerText = `${badgeTextSaleType}`
                }
            }
        }
    }
}



customElements.define('variant-radios', VariantRadios);

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        if (this.closest('.quick-order-list__contents')) return; 
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.input.addEventListener('change', this.onInputChange.bind(this));

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );

        if (!this.checkHasMultipleVariants()) {
            this.initProductQuantity();
            this.checkVariantInventory();
        }
    }

    onInputChange(event) {
        event.preventDefault(); 
        var inputValue = this.input.value;
        var maxValue = parseInt(this.input.dataset.inventoryQuantity);
        var currentId = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="id"]')?.value;
        var saleOutStock  = document.getElementById('product-add-to-cart')?.dataset.available === 'true' || false ;
        const addButton = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="add"]');

        if(inputValue < 1) {
            inputValue = 1;

            this.input.value =  inputValue;
        }
        
        if (inputValue > maxValue && !saleOutStock && maxValue > 0) {
            var arrayInVarName = `selling_array_${this.input.dataset.product}`,
                itemInArray = window[arrayInVarName],
                itemStatus = itemInArray[currentId];
          
            if(itemStatus == 'deny') {
              inputValue = maxValue
              this.input.value = inputValue;
              const message = getInputMessage(maxValue)
              showWarning(message, 3000)
            }
        } else if (inputValue > maxValue && saleOutStock && maxValue <= 0) {
            this.input.value = inputValue;
        }

        if(window.subtotal.show) {
            var text,
                price = this.input.dataset.price,
                subTotal = 0;

            var parser = new DOMParser();

            subTotal = inputValue * price;
            subTotal = Shopify.formatMoney(subTotal, window.money_format);
            subTotal = extractContent(subTotal);

            const moneySpan = document.createElement('span')
            moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal') 
            moneySpan.innerText = subTotal 
            document.body.appendChild(moneySpan) 

            if (this.checkNeedToConvertCurrency()) {
                let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
            }

            subTotal = moneySpan.innerText 
            $(moneySpan).remove()

            if (window.subtotal.style == '1') {
                const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');

                pdView_subTotal.textContent = subTotal;
            }
            else if (window.subtotal.style == '2') {
                text = window.subtotal.text.replace('[value]', subTotal);
                $('#product-sticky-add-to-cart').text(text);
                if (addButton != null){
                    addButton.textContent = text;
                }
            }

            const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
            const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

            if (stickyPrice.length) {
                stickyPrice.text(subTotal);
            }

            if (stickyComparePrice.length && window.subtotal.show) {
                let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price');
                comparePrice = inputValue * comparePrice;
                comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                comparePrice = extractContent(comparePrice);
                stickyComparePrice.text(comparePrice);
            }
        }

        if (this.classList.contains('quantity__group--2') || this.classList.contains('quantity__group--3')) {
            const mainQty = document.querySelector('.quantity__group--1 .quantity__input');
            if (mainQty != null){
                mainQty.value = inputValue;
            }

            const mainQty2Exists = !!document.querySelector('.quantity__group--2 .quantity__input');
            const mainQty3Exists = !!document.querySelector('.quantity__group--3 .quantity__input');

            if (this.classList.contains('quantity__group--2') && mainQty3Exists) {
                const mainQty3 = document.querySelector('.quantity__group--3 .quantity__input');
                mainQty3.value = inputValue;
            }
            else if (this.classList.contains('quantity__group--3') && mainQty2Exists) {
                const mainQty2 = document.querySelector('.quantity__group--2 .quantity__input');
                mainQty2.value = inputValue;
            }
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    checkNeedToConvertCurrency() {
        return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
    }
    
    checkHasMultipleVariants() {
        const arrayInVarName = `product_inven_array_${this.querySelector('[data-product]').dataset.product}`
        this.inven_array = window[arrayInVarName];
        return Object.keys(this.inven_array).length > 1
    }
        
    initProductQuantity() {
        if(this.inven_array != undefined) {
            var inven_num = Object.values(this.inven_array),
                inventoryQuantity = parseInt(inven_num);

            this.querySelector('input[name="quantity"]').setAttribute('data-inventory-quantity', inventoryQuantity);
            this.querySelector('input[name="quantity"]').dataset.inventoryQuantity = inventoryQuantity
        }
    }

    checkVariantInventory() {
        const addBtn = document.getElementById('product-add-to-cart');
        if (!addBtn) return;
        this.input.disabled = addBtn.disabled;
        this.querySelector('.btn-quantity.minus').disabled = addBtn.disabled;
        this.querySelector('.btn-quantity.plus').disabled = addBtn.disabled;
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(document.querySelector('.product-option [type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('quantity-input', QuantityInput);

function hotStock(inventoryQuantity) {
    const productView = document.querySelector('.productView');
    const hotStock = productView.querySelector('.productView-hotStock');
    if(hotStock) {
        let hotStockText = hotStock.querySelector('.hotStock-text'),
            maxStock = parseFloat(hotStock.dataset.hotStock),
            textStock;

        if(inventoryQuantity > 0 && inventoryQuantity <= maxStock){
            hotStock.matches('.style-2') ? textStock  = window.inventory_text.hotStock2.replace('[inventory]', inventoryQuantity) : textStock  = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);
            if (hotStockText) hotStockText.innerHTML = textStock;
            hotStock.classList.remove('is-hide');
        } else {
            hotStock.classList.add('is-hide');
        }

        if (hotStock.matches('.style-2')) {
            const invenProgress = inventoryQuantity / maxStock * 100,
                hotStockProgressItem = hotStock.querySelector('.hotStock-progress-item');
            if (hotStockProgressItem) hotStockProgressItem.style.width = `${invenProgress}%`;
        }
    }
}
const hotStockNoOptions = document.querySelector('.productView .productView-hotStock[data-current-inventory]');
if (hotStockNoOptions) {
    const inventoryQuantity = parseFloat(hotStockNoOptions.dataset.currentInventory);
    hotStock(inventoryQuantity);
}


function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}

